import React, { useState, useEffect } from 'react';
import RoutePaths from './routes/RoutePaths';


function App() {
  // page loader
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);



  return (
    <>
      <div>
        {loading ? (
          <div className='page-loader'>
            <div className="food-loader">
              <div className="food-icon burger"></div>
              <div className="food-icon pizza"></div>
              <div className="food-icon donut"></div>
            </div>
          </div>
        ) : (
          <>
            <RoutePaths />
          </>
        )}
      </div>
    </>
  );
}

export default App;
